import { refs, domReady } from '../modules/utils.js';

class BlogGrid extends HTMLElement {
  static get observedAttributes() {
    return [];
  }

  attributeChangedCallback(name, oldValue, newValue) { }

  async connectedCallback() {
    await domReady();
    this.refs = refs(this);
    this.#listeners();
  }

  #listeners() {
    this.refs.loadMore?.addEventListener('click', (e) => {
      e.preventDefault();
      this.#loadNewPage();
    });
  }

  #loadNewPage() {
    if (this.hasAttribute('data-is-loading')) return;
    this.toggleAttribute('data-is-loading', true);

    fetch(this.refs.loadMore.href)
      .then(res => res.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const items = doc.querySelectorAll('.postcard');
        const loaderLink = doc.querySelector('[data-ref="loadMore"]');

        items.forEach(item => {
          this.refs.postsContainer.appendChild(item);
        });

        this.toggleAttribute('data-is-loading', false);

        if (!loaderLink) {
          this.refs.loadMore.parentNode.remove();
          delete this.refs.loadMore;
        }

      });
  }
}

customElements.define('blog-grid', BlogGrid);
